import { MutableRefObject, useEffect } from "react"

export const useParallaxAnimation = (options: {
  mediaRef: MutableRefObject<HTMLDivElement | null>
  wrapperRef: MutableRefObject<HTMLDivElement | null>
  mediaWrapperRef: MutableRefObject<HTMLDivElement | null>
  enabled?: boolean
}) => {
  const { mediaRef, mediaWrapperRef, wrapperRef, enabled } = options

  useEffect(() => {
    if (mediaRef.current && wrapperRef.current && mediaWrapperRef && !!window && enabled) {
      const updateMediaPosition = () => {
        requestAnimationFrame(() => {
          if (!mediaRef.current || !wrapperRef.current || !mediaWrapperRef.current) return
          if (window.innerWidth < 1130) {
            mediaRef.current.style.transform = `translateY(0)`
            return
          }

          const scrollPosition = window.scrollY + window.innerHeight / 2
          const relativeScrollPosition = scrollPosition - wrapperRef.current.offsetTop
          const relativeScrollPercentage = relativeScrollPosition / wrapperRef.current.offsetHeight

          const startMediaPosition = 0
          const endMediaPosition = mediaWrapperRef.current.offsetHeight - mediaRef.current.offsetHeight

          const interpolatedMediaPosition = Math.min(
            endMediaPosition,
            Math.max(
              startMediaPosition,
              startMediaPosition + (endMediaPosition - startMediaPosition) * relativeScrollPercentage,
            ),
          )

          mediaRef.current.style.transform = `translateY(${interpolatedMediaPosition}px)`
        })
      }

      updateMediaPosition()

      window.addEventListener('scroll', updateMediaPosition)
      window.addEventListener('resize', updateMediaPosition)

      return () => {
        window.removeEventListener('scroll', updateMediaPosition)
        window.removeEventListener('resize', updateMediaPosition)
      }
    }
  }, [enabled])
}